import { useState } from "react";
import styled from "styled-components";
import CenterDiv from "../../../../../style/styled-components/components/CenterDiv";
import UseBreakpoints from "../../../../hooks/ui/UseBreakpoints";
import SelectOne from "../../../common/SelectOne";
import BranchMapHOC from "./BranchMapHOC";
const BranchDetails = ({ detail }) => {
  const breakpoints = UseBreakpoints();
  const [selected, setSelected] = useState(0);
  return (
    <Div breakpoints={breakpoints}>
      <div>
        <BranchNameSpan>{detail.name}</BranchNameSpan>
        <ul>
          {detail.branches?.map((x) => (
            <li key={x}>{x}</li>
          ))}
        </ul>
        <AddressDiv>
          <div>🏢</div>
          <AddressSpan>
            {detail.address1} <span>{detail.addressKey}</span>
          </AddressSpan>

          <AddressSpan>{detail.address2}</AddressSpan>
        </AddressDiv>
        <ContactDiv>
          <div>
            <TelSpan title="tel">📞 {detail.tel}</TelSpan>
          </div>
          {detail?.fax && (
            <div>
              <TelSpan title="fax">📠 {detail.fax}</TelSpan>
            </div>
          )}
        </ContactDiv>
        <CenterDiv>
          <SelectOne
            options={["오시는 길", "카카오맵"]}
            selected={selected}
            setSelected={setSelected}
          />
        </CenterDiv>
      </div>
      <BranchMapHOC selected={selected} detail={detail} />
    </Div>
  );
};
export default BranchDetails;
const Div = styled.div`
  display: flex;
  flex-direction: ${({ breakpoints }) => (breakpoints?.xl ? "row" : "column")};
  border-radius: 1.25rem;
  border: 1px solid ${({ theme }) => theme.colors.line};
  background-color: white;
  overflow: hidden;
  & > div:first-child {
    min-width: ${({ breakpoints }) => (breakpoints?.md ? "17rem" : null)};
    max-width: ${({ breakpoints }) => (breakpoints?.xl ? "20rem" : null)};
    display: flex;
    flex-direction: column;
    gap: 1rem;
    color: ${({ theme }) => theme.colors?.foreground.dimmed};
    background: linear-gradient(180deg, ${({ theme }) => theme.colors.extralight}, white);
    padding: 2rem 1.75rem;
    & > hr {
      width: 100%;
    }
    & ul {
      margin: 0;
      padding-left: 1.1rem;
      & li {
        line-height: 1.9;
        color: ${({ theme }) => theme.colors.monotone.dark};
      }
    }
  }
`;
const BranchNameSpan = styled.span`
  font-size: 1.6rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colors?.dark};
`;
const AddressSpan = styled.span`
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.monotone.dark};
  & > span {
    font-weight: 700;
  }
`;

const TelSpan = styled.span``;
const ContactDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.monotone.dark};
`;
const AddressDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  border-radius: 0.75rem;
  padding: 1rem 1.1rem;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.colors.line};
  font-size: 0.95rem;
  & > div:first-child {
    font-size: 1.1rem;
  }
`;
